export function MailOutline({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="2"
          y="3.75"
          width="14"
          height="10.5"
          rx="3"
          stroke="currentColor"
          strokeWidth="1.4"
        />
        <path
          d="M4.95 6.75L8.05 9.19C8.61 9.63 9.39 9.63 9.95 9.19L13.05 6.75"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
